import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export const LegalLayout = ({ title, updated, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F4F6F3] text-[#04162E]">
      <header className="sticky top-0 z-40 bg-[#04162E]/95 backdrop-blur-md border-b border-white/15">
        <div className="mx-auto max-w-[1180px] px-5 lg:px-8 h-[76px] flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" aria-label="Home">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 font-body text-[14.5px] font-medium text-[#D7DEE7] hover:text-white transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Site
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 lg:px-8 py-16 lg:py-20">
        <span className="font-body text-[13px] font-semibold text-[#0B6B44]">Legal</span>
        <h1 className="mt-3 font-display font-bold text-4xl sm:text-5xl leading-[1.1] text-[#04162E]">
          {title}
        </h1>
        <p className="mt-3 font-body text-sm text-[#8FA0B3]">Last updated: {updated}</p>

        <div className="mt-10 space-y-8 font-body leading-[1.65] text-[15px] text-[#5C6C80]">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section className="pt-8 border-t border-[rgba(4,22,46,0.14)]">
    <h2 className="font-display text-[22px] font-bold text-[#04162E] mb-3">{heading}</h2>
    <div className="space-y-3 text-[#5C6C80]">{children}</div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2 text-[#5C6C80] list-disc pl-5 marker:text-[#0E8A57]">
    {items.map((it) => (
      <li key={it}>{it}</li>
    ))}
  </ul>
);
